import { render, staticRenderFns } from "./SubscribersList.vue?vue&type=template&id=01a4f8a9"
import script from "./SubscribersList.vue?vue&type=script&lang=js"
export * from "./SubscribersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports